import { Link } from "react-router-dom";
import { siteMeta } from "@/mocks/manga";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/catalog", label: "阅读目录" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

const categoryLinks = [
  { to: "/catalog", label: "单行本全卷" },
  { to: "/catalog", label: "连载话" },
  { to: "/catalog", label: "全彩版本" },
  { to: "/catalog", label: "番外收录" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteMeta.shortName}
                <span className="ml-1.5 text-xs font-medium text-primary-600">漫画网</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注《甜蜜惩罚》漫画单行本全卷、连载话、全彩版本与番外收录，按卷与话数整理目录，找齐整部作品更方便。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">内容分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((l, i) => (
                <li key={i}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-primary-500"></i>
                <span>support@sweetmanga.example.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-primary-500"></i>
                <span>内容更新 · 随时欢迎阅读</span>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 {siteMeta.name} · 用心整理每一卷甜蜜</p>
          <p className="text-xs text-foreground-500">单行本全卷 · 连载话 · 全彩版本 · 番外收录</p>
        </div>
      </div>
    </footer>
  );
}